/** @jsxImportSource @emotion/react */
import PropTypes from 'prop-types'
import {
  largeCardStyle,
  largeCardStyleSelected,
  largeCardThumbnailStyle,
  largeCardContentStyle,
  largeCardTitleStyle,
  largeCardLabelStyle,
  playingIndicatorStyle,
  largeCardThumbnailWithCoverStyle,
} from '../styles'
import { getImageThumbnailId } from '@sportninja/common/utils/utils'

/**
 * FullGameCard component for displaying the full game highlight
 * @param {Object} props - Component props
 * @param {Object} props.game - Game data
 * @param {Function} props.onClick - Click handler
 * @param {boolean} props.isPlaying - Whether this card's video is currently playing
 * @returns {JSX.Element} FullGameCard component
 */
const FullGameCard = ({ game, onClick, isPlaying }) => {
  const handleClick = () => {
    if (onClick) {
      onClick(game)
    }
  }

  return (
    <div
      css={isPlaying ? largeCardStyleSelected : largeCardStyle}
      onClick={handleClick}
    >
      <img
        src={
          game?.thumbnail
            ? game.thumbnail
            : '/images/generic_placeholders/placeholder_video.png'
        }
        alt={game.title}
        css={
          game?.thumbnail
            ? largeCardThumbnailWithCoverStyle
            : largeCardThumbnailStyle
        }
        onError={(e) => {
          e.target.src = '/images/generic_placeholders/placeholder_video.png'
        }}
      />
      <div css={largeCardContentStyle}>
        <div css={largeCardTitleStyle}>{game.title}</div>
        <div css={largeCardLabelStyle}>{game.label}</div>
      </div>
      {isPlaying && <div css={playingIndicatorStyle} />}
    </div>
  )
}

FullGameCard.propTypes = {
  game: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    thumb: PropTypes.string.isRequired,
    videoUrl: PropTypes.string.isRequired,
  }).isRequired,
  onClick: PropTypes.func,
  isPlaying: PropTypes.bool,
}

FullGameCard.defaultProps = {
  onClick: null,
  isPlaying: false,
}

export default FullGameCard
